/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingsControllerCreateMutationRequest, BidLevelingsControllerCreateMutationResponse, BidLevelingsControllerCreate400, BidLevelingsControllerCreate401, BidLevelingsControllerCreate403 } from "../../models/bidsController/BidLevelingsControllerCreate";

function getBidLevelingsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/bid-levelings` as const }  
  return res
}

/**
 * @summary Create a trade
 * {@link /api/v1/bid-levelings}
 */
export async function bidLevelingsControllerCreate(data?: BidLevelingsControllerCreateMutationRequest, config: Partial<RequestConfig<BidLevelingsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<BidLevelingsControllerCreateMutationResponse, ResponseErrorConfig<BidLevelingsControllerCreate400 | BidLevelingsControllerCreate401 | BidLevelingsControllerCreate403>, BidLevelingsControllerCreateMutationRequest>({ method : "POST", url : getBidLevelingsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}